module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('b-list-group', {
    staticClass: "d-flex flex-fill",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "258px"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      key: item.id,
      staticClass: "flex-column align-items-start p-2"
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h6', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("since")(item.updatedTimestamp)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-monospace"
    }, [_vm._v(_vm._s(_vm._f("ellipsis")(item.query, 50)))]), _vm._v(" "), _c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('small', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('span', [_c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Delete this query"
      },
      on: {
        "click": function($event) {
          return _vm.deleteQuery(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "trash"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Copy the query into the workbench"
      },
      on: {
        "click": function($event) {
          return _vm.copyQuery(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "clone"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Execute this query"
      },
      on: {
        "click": function($event) {
          return _vm.executeQuery(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "play"
      }
    })], 1)], 1)])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a51058","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SavedQueries.vue
// module id = 2150
// module chunks = 1